import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { hrEmployerApi } from "@/lib/api/hr";
import { EmptyState, Page, Panel } from "@/components/shell/page";
import { todayIST } from "@/lib/timezone";

export default function EmployerCalendarPage() {
  const [month, setMonth] = useState(todayIST().slice(0, 7));
  const { data } = useQuery({
    queryKey: ["hr", "employer", "calendar", month],
    queryFn: () => hrEmployerApi.calendar(month),
  });

  return (
    <Page
      title="Calendar"
      description="Holidays and approved leave for the month."
      actions={
        <input
          type="month"
          aria-label="Month"
          className="field-control w-auto"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        />
      }
    >
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel title="Holidays">
          {(data?.holidays ?? []).length === 0 && (
            <EmptyState title="No holidays" body="None are recorded for this month." />
          )}
          <ul className="divide-y">
            {(data?.holidays ?? []).map((holiday: any) => (
              <li key={holiday.date} className="flex justify-between py-3 text-sm first:pt-0 last:pb-0">
                <span className="font-medium">{holiday.name}</span>
                <span className="text-muted-foreground">{holiday.date}</span>
              </li>
            ))}
          </ul>
        </Panel>
        <Panel title="Approved leave">
          {(data?.leaves ?? []).length === 0 && (
            <EmptyState title="No approved leave" body="Approved requests for this month show up here." />
          )}
          <ul className="divide-y">
            {(data?.leaves ?? []).map((row: any, index: number) => (
              <li key={index} className="py-3 text-sm first:pt-0 last:pb-0">
                <p className="font-medium">Employee {row.employee_id}</p>
                <p className="text-muted-foreground">
                  {row.start_date} – {row.end_date}
                </p>
              </li>
            ))}
          </ul>
        </Panel>
      </div>
    </Page>
  );
}
